import { j as t } from "../../../jsx-runtime-B3iL8JI7.js";
import { cardStyles as S } from "./Card.styles.js";
import N from "../../atoms/Button/Button.js";
import o from "../../../tailwindConfig/bclTwMerge.js";
import "@radix-ui/react-checkbox";
import "../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/react-fontawesome";
import "../../atoms/Icon/Icon.utilities.js";
import "../../atoms/Icon/Icon.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import "../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import "../../atoms/TextField/TextField.styles.js";
import "../../atoms/TextLink/TextLink.styles.js";
import f from "../../atoms/Chip/Chip.js";
import "@radix-ui/react-radio-group";
import "../../atoms/RadioItem/RadioItem.styles.js";
import "../../../tailwindConfig/colors/index.js";
import "../../../tailwindConfig/fontSize/fontSize.js";
import "../../../tailwindConfig/plugins/gradientUtilities.plugin.js";
import "../../../tailwindConfig/plugins/rootStyles.plugin.js";
import "@tailwindcss/container-queries";
import "@tailwindcss/aspect-ratio";
const Z = ({
  imageLink: i,
  imageDescription: s,
  chips: r = [],
  headingText: a,
  descriptionText: e,
  buttonProps: m,
  className: p = "",
  buttonClass: n = ""
}) => {
  const {
    base: l,
    imageContainer: c,
    image: d,
    chipsContainer: x,
    heading: h,
    descriptionText: j,
    buttonContainer: g
  } = S;
  return /* @__PURE__ */ t.jsxs("div", { className: o(l, p), children: [
    i && /* @__PURE__ */ t.jsx("div", { className: c, children: /* @__PURE__ */ t.jsx("img", { src: i, alt: s, className: d }) }),
    r.length > 0 && /* @__PURE__ */ t.jsx("div", { className: x, children: r.slice(0, 2).map((y, C) => /* @__PURE__ */ t.jsx(f, { ...y }, C)) }),
    /* @__PURE__ */ t.jsx("h1", { className: h, children: a }),
    e && /* @__PURE__ */ t.jsx("p", { className: j, children: e }),
    m && /* @__PURE__ */ t.jsx("div", { className: o(g, n), children: /* @__PURE__ */ t.jsx(N, { ...m }) })
  ] });
};
export {
  Z as default
};
